import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import DictionaryPage from './pages/DictionaryPage'
import reportWebVitals from './reportWebVitals'
import { AlertProvider } from './context/AlertContext'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Div100vh from 'react-div-100vh'

ReactDOM.render(
  <React.StrictMode>
    <AlertProvider>
      <BrowserRouter>
        <Div100vh>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/dictionary" element={<DictionaryPage />} />
          </Routes>
        </Div100vh>
      </BrowserRouter>
    </AlertProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
